<div class="flex flex-row gap-2 justify-between" [ngClass]="{ 'mb-4': !subtitle() }">
  <h1
    class="text-2xl font-medium"
    [ngClass]="{
    'text-center': centered(),
    'w-full': centered(),
  }"
  >
    <ng-content/>
  </h1>
  <ng-content select="[rightSlot]"/>
</div>
@if (subtitle()) {
  <p class="mb-4">{{ subtitle() }}</p>
}
